import { useNavigate } from "react-router-dom";
import StatusBadge from "../../components/activities/statusBadge";
import TypeBadge from "../../components/activities/typeBadge";
import RankingBadge from "../../components/activities/rankingBadge";

export default function CoachActivityRow({ activity, coachId, idx }) {
  const navigate = useNavigate();

  return (
    <div
      className="p-2 flex flex-col gap-1 hover:bg-gray-50 cursor-pointer"
      onClick={() => navigate(`/activities/${activity.id}`, { state: { from: "other-coach-side", coachId: coachId }})}
    >
      <div className="flex items-start gap-1 text-left">
        <span className="text-gray-500 shrink-0">
          {idx + 1}.
        </span>
        <span className="text-blue-600 underline hyphens-auto">
          {activity.name}
        </span>
      </div>

      <div className="flex flex-wrap gap-1 justify-end">
        <StatusBadge status={activity.status} />
        <TypeBadge type={activity.type} />
        {activity.type === "tournament" && (
          <RankingBadge ranking={activity.rankingType} />
        )}
      </div>
    </div>
  );
}
